// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.te-pipeline-debug {
  margin: 0 0 1rem;
  border: 1px solid rgba(8, 119, 188, 0.35);
  border-radius: 12px;
  background: linear-gradient(180deg, rgba(8, 119, 188, 0.06), rgba(8, 119, 188, 0.02));
  overflow: hidden;
}

.te-pipeline-debug__toggle {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
  padding: 0.75rem 1rem;
  border: none;
  background: transparent;
  cursor: pointer;
  font-weight: 700;
  color: #0877bc;
  text-align: left;
}

.te-pipeline-debug__body {
  padding: 0 1rem 1rem;
}

.te-pipeline-debug__toolbar {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-bottom: 0.75rem;
  align-items: center;
}

.te-pipeline-debug__meta {
  font-size: 0.8rem;
  color: #64748b;
  margin-bottom: 0.75rem;
}

.te-pipeline-debug__card {
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  background: #fff;
  margin-bottom: 0.75rem;
  overflow: hidden;
}

.te-pipeline-debug__card-head {
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem 0.75rem;
  align-items: center;
  padding: 0.65rem 0.85rem;
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
}

.te-pipeline-debug__card-title {
  font-weight: 700;
  font-size: 0.95rem;
  margin: 0;
}

.te-pipeline-debug__card-body {
  padding: 0.75rem 0.85rem;
  font-size: 0.82rem;
}

.te-pipeline-debug__grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 0.35rem 0.75rem;
  margin-bottom: 0.75rem;
}

.te-pipeline-debug__checklist {
  list-style: none;
  margin: 0;
  padding: 0;
}

.te-pipeline-debug__checklist li {
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 0.5rem;
  padding: 0.35rem 0;
  border-bottom: 1px dashed #e2e8f0;
}

.te-pipeline-debug__checklist li:last-child {
  border-bottom: none;
}

.te-pipeline-debug__pill {
  display: inline-flex;
  align-items: center;
  padding: 0.1rem 0.45rem;
  border-radius: 999px;
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.02em;
}

.te-pipeline-debug__pill--ok {
  background: #dcfce7;
  color: #166534;
}

.te-pipeline-debug__pill--warn {
  background: #fef9c3;
  color: #854d0e;
}

.te-pipeline-debug__pill--fail {
  background: #fee2e2;
  color: #991b1b;
}

.te-pipeline-debug__pill--info {
  background: #e0f2fe;
  color: #075985;
}

.te-pipeline-debug__section-title {
  font-size: 0.78rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #64748b;
  margin: 0.65rem 0 0.35rem;
}

.te-pipeline-debug__mono {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 0.75rem;
  word-break: break-all;
}

.te-pipeline-debug__video-row {
  padding: 0.35rem 0;
  border-bottom: 1px solid #f1f5f9;
}

.te-pipeline-debug__error {
  color: #b91c1c;
  font-size: 0.85rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/TePipelineDebugPanel.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,yCAAyC;EACzC,mBAAmB;EACnB,qFAAqF;EACrF,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,qBAAqB;EACrB,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,wBAAwB;EACxB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,WAAW;EACX,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,6EAA6E;EAC7E,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB","sourcesContent":[".te-pipeline-debug {\n  margin: 0 0 1rem;\n  border: 1px solid rgba(8, 119, 188, 0.35);\n  border-radius: 12px;\n  background: linear-gradient(180deg, rgba(8, 119, 188, 0.06), rgba(8, 119, 188, 0.02));\n  overflow: hidden;\n}\n\n.te-pipeline-debug__toggle {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  width: 100%;\n  padding: 0.75rem 1rem;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  font-weight: 700;\n  color: #0877bc;\n  text-align: left;\n}\n\n.te-pipeline-debug__body {\n  padding: 0 1rem 1rem;\n}\n\n.te-pipeline-debug__toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  margin-bottom: 0.75rem;\n  align-items: center;\n}\n\n.te-pipeline-debug__meta {\n  font-size: 0.8rem;\n  color: #64748b;\n  margin-bottom: 0.75rem;\n}\n\n.te-pipeline-debug__card {\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  background: #fff;\n  margin-bottom: 0.75rem;\n  overflow: hidden;\n}\n\n.te-pipeline-debug__card-head {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.35rem 0.75rem;\n  align-items: center;\n  padding: 0.65rem 0.85rem;\n  background: #f8fafc;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.te-pipeline-debug__card-title {\n  font-weight: 700;\n  font-size: 0.95rem;\n  margin: 0;\n}\n\n.te-pipeline-debug__card-body {\n  padding: 0.75rem 0.85rem;\n  font-size: 0.82rem;\n}\n\n.te-pipeline-debug__grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));\n  gap: 0.35rem 0.75rem;\n  margin-bottom: 0.75rem;\n}\n\n.te-pipeline-debug__checklist {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.te-pipeline-debug__checklist li {\n  display: grid;\n  grid-template-columns: auto 1fr;\n  gap: 0.5rem;\n  padding: 0.35rem 0;\n  border-bottom: 1px dashed #e2e8f0;\n}\n\n.te-pipeline-debug__checklist li:last-child {\n  border-bottom: none;\n}\n\n.te-pipeline-debug__pill {\n  display: inline-flex;\n  align-items: center;\n  padding: 0.1rem 0.45rem;\n  border-radius: 999px;\n  font-size: 0.72rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.02em;\n}\n\n.te-pipeline-debug__pill--ok {\n  background: #dcfce7;\n  color: #166534;\n}\n\n.te-pipeline-debug__pill--warn {\n  background: #fef9c3;\n  color: #854d0e;\n}\n\n.te-pipeline-debug__pill--fail {\n  background: #fee2e2;\n  color: #991b1b;\n}\n\n.te-pipeline-debug__pill--info {\n  background: #e0f2fe;\n  color: #075985;\n}\n\n.te-pipeline-debug__section-title {\n  font-size: 0.78rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: #64748b;\n  margin: 0.65rem 0 0.35rem;\n}\n\n.te-pipeline-debug__mono {\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  font-size: 0.75rem;\n  word-break: break-all;\n}\n\n.te-pipeline-debug__video-row {\n  padding: 0.35rem 0;\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.te-pipeline-debug__error {\n  color: #b91c1c;\n  font-size: 0.85rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
